
















import Vue from 'vue';
import { CALL_TYPES } from '@/resources/defines';

export default Vue.extend({
  name: 'DataTableItemCallType',

  props: {
    value: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      callTypes: CALL_TYPES,
    };
  },
});
